<template>
    <!-- <q-dialog v-if="true" class="modal"> -->
        <q-card class="modal__wrap">
            <q-card-section class="row items-center q-pb-none">
                <q-space />
                <q-btn class="close" icon="close" flat round dense v-close-popup />
            </q-card-section>
            <q-separator />
            <div class="modal__content">
                <div class="title">
                    <div class="filterTt10">레벨 선택tttest</div>
                    <q-btn unelevated no-ripple :onClick="onInitFilter" class="btn__filter roundedBtnOut">
                        <span class="roundedBtnTt30">필터초기화</span>
                    </q-btn>
                    <!-- <q-btn flat label="필터초기화" class="btn__filter" style="border: 1px solid #8e8e8e" :onClick="onInitFilter" /> -->
                </div>

                <q-checkbox v-model="isAll1" class="modal__checkbox" @click="onAll1" val="all" label="모든 레벨" color="primary" />
                <div class="flex align-center + justify-left">
                    <template v-for="e in cbList1" :key="e.idx">
                        <q-checkbox class="modal__checkbox" v-model="selection1" :val="e.value" :label="e.label" color="primary" />
                    </template>
                </div>

                <!-- <q-checkbox class="modal__checkbox" v-model="isAll1" label="모든레벨" :onClick="onAll1" />
                <q-option-group class="modal__checkbox" inline v-model="isAll1" :options="cbList1" color="primary" type="checkbox" /> -->
                <q-separator style="margin-top: 2.6vmin" />
                <div class="title">
                    <div class="filterTt10">갈래/주제 선택</div>
                </div>

                <q-checkbox v-model="isAll2" class="modal__checkbox" @click="onAll2" val="all" label="모든 갈래/주제" color="primary" />
                <div class="flex align-center + justify-left">
                    <template v-for="e in cbList2" :key="e.idx">
                        <q-checkbox class="modal__checkbox" v-model="selection2" :val="e.value" :label="e.label" color="primary" />
                    </template>
                </div>

                <!-- <q-checkbox class="modal__checkbox" v-model="isAll2" label="모든영역" :onClick="onAll2" />
                <q-option-group class="modal__checkbox" inline v-model="isAll2" :options="cbList2" type="checkbox" /> -->
            </div>
            <!-- tttd -->
            <q-card-actions align="center" class="mg_bottom_32">
                <q-btn unelevated no-ripple class="btn__submit roundedBtnOutPrimary" style="width: 50%" @keydown.enter="onCompleteFilter" @click="onCompleteFilter">
                    <span class="roundedBtnTt30WHITE">필터 적용</span>
                </q-btn>
                <!-- <CqBtn class="btn__submit" color="primary" style="width: 50%" label="필터 적용" @keydown.enter="onCompleteFilter" @click="onCompleteFilter" /> -->
            </q-card-actions>
        </q-card>
    <!-- </q-dialog> -->
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';
import { searchContents } from '@/api/modules/user_map.js';
import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

const popFilter = ref(false);
const popFilter2 = ref(false);
const rows = ref();
let totalData, resultData;
const keyword = ref();
const pagination = ref({
    page: 1,
    rowsPerPage: 0,
});

//---------------검색필터---------------//
const cbList1 = [
    { idx: 0, value: '1', label: '레벨1' },
    { idx: 1, value: '2', label: '레벨2' },
    { idx: 2, value: '3', label: '레벨3' },
];
const isAll1 = ref(false);
const selection1 = ref([]);
watch(selection1, (nSel, oSel) => {
    if (nSel.length < cbList1.length) isAll1.value = false;
    if (nSel.length === cbList1.length) isAll1.value = true;
    // else onAll1();
    // if (nSel.length < cbList1.length) isAll1.value = false;
});
const cbList2 = [
    { idx: 0, value: 'Y1_01', label: '현대시' },
    { idx: 1, value: 'Y1_02', label: '현대소설' },
    { idx: 2, value: 'Y1_03', label: '고전시가' },
    { idx: 3, value: 'Y1_04', label: '고전산문' },
    { idx: 4, value: 'Y1_05', label: '극수필' },
    { idx: 5, value: 'Y5_01', label: '인문' },
    { idx: 6, value: 'Y5_02', label: '과학' },
    { idx: 7, value: 'Y5_03', label: '정치사회' },
    { idx: 8, value: 'Y5_04', label: '예술' },
    { idx: 9, value: 'Y5_05', label: '기술' },
    { idx: 10, value: 'Y5_06', label: '경제문화' },
    { idx: 11, value: 'Y5_07', label: '융합' },
];
const isAll2 = ref(false);
const selection2 = ref([]);
watch(selection2, (nSel, oSel) => {
    if (nSel.length < cbList2.length) isAll2.value = false;
    if (nSel.length === cbList2.length) isAll2.value = true;
});

const setData = async () => {
    const res = await searchContents(gStore.token, [...selection1.value], [...selection2.value]);
    // console.log('--contents--res:', res);
    if (res && res.status === 200) {
        if (!totalData) totalData = res.data.data; // 처음에만
        rows.value = res.data.data;
    }
};

onMounted(() => {
    selection1.value = cbList1.map((e) => e.value);
    selection2.value = cbList2.map((e) => e.value);
    setData();
});

////////////////////////////----OnClick----////////////////////////////

const onAll1 = () => {
    // console.log('--checkedAll--bool:', bool);
    if (isAll1.value) selection1.value = cbList1.map((e) => e.value);
    else selection1.value = [];
};

const onAll2 = () => {
    // console.log('--checkedAll--bool:', bool);
    if (isAll2.value) selection2.value = cbList2.map((e) => e.value);
    else selection2.value = [];
};

const onMoveStudyRecords = () => {
    // console.log('--onMoveStudyRecords-- :');
    router.push('/map');
};
const onHome = () => {
    router.push('/learninghome');
};
const showFilter = () => {
    // console.log('llll-showFilter---');
    isAll1.value = selection1.value.length === cbList1.length;
    isAll2.value = selection2.value.length === cbList2.length;
    // popFilter.value = true;
    popFilter2.value = true;
};
const onInitFilter = () => {
    selection1.value = cbList1.map((e) => e.value);
    selection2.value = cbList2.map((e) => e.value);
    // selection1.value = [];
    // selection2.value = [];
};
const onSearch = () => {
    keyword.value = keyword.value.replace(/ /g, '');
    const word = keyword.value;

    if (word) rows.value = totalData.filter((e) => e.passageName.includes(word));
    else rows.value = totalData;
};

const onCompleteFilter = () => {
    popFilter2.value = false;
    setData();
};
</script>

<style scoped lang="scss">
.roundedBtnOut {
    padding: 1.17vmin 3.33vmin;
    border-radius: 1.3vmin;
    border: 1px solid black;
    background-color: white;
}

.roundedBtnOutPrimary {
    margin: 0;
    padding: 1.17vmin 3.33vmin;
    border-radius: 1.3vmin;
    /* border: 1px solid black;  */
    background-color: #8e43f0;
}

.btn__filter {
    color: #000000;
    font-size: 1.5vmin;
    font-weight: 500 !important;
    border: 2px solid #8e8e8e;
    border-radius: 8px;
    padding: 1vmin 2vmin;

    .q-btn__content {
        .block {
            font-weight: 500 !important;
        }
    }
}

.circle {
    border-radius: 10px;
}

.q-checkbox__bg {
    border-radius: 10px;
}

// tr {
/* text-align: left; */
/* background-color: bisque;  */
// }

q-table:deep(q-td) {
    text-align: center;
    background-color: aqua;
}
// ttta
.commonTable {
    font-size: 10px;
}

table th {
    // text-align: center;
    // width: 100px;
    background-color: #fafafa;
    text-align: center;
    // max-width: 100px;
    height: 1vw;
    font-size: 1.2vw;
    padding: 30px 10px;
    word-break: break-all;
}
table td {
    background-color: #fff;
    text-align: center;
    max-width: 12.5vw;
    height: 1vw;
    font-size: 1.2vw;
    padding: 24px 10px;
    word-break: break-all;
    &:nth-of-type(2) {
        max-width: 16.75vw;
    }
    &:nth-of-type(4) {
        max-width: 20.6vw;
        text-align: left;
        white-space: inherit;
    }
}

// ::v-deep .q-table {
//     // font-size: 2vw;
//     th {
//         height: 1vw;
//         font-size: 1.2vw;
//         text-align: right;
//         padding: 20px;
//         background-color: #fafafa;
//     }

//     td {
//         font-size: 1.2vw;
//         max-width: 100px;
//         font-weight: 400;
//         text-align: center;
//     }
// }

.modal {
    .title {
        color: #222222;
        font-size: 1.5vw;
        font-weight: 700;
        margin: 4.08vmin 0vmin 2.92vmin;
        display: flex;
        justify-content: space-between;
        align-items: center;

        & + .q-checkbox::v-deep {
            width: 15vw;
        }
    }

    &__wrap {
        width: 50vw;
        min-width: 500px;
        max-width: 1000px;
        border-radius: 2.5vmin;
    }

    &__content {
        padding: 0vmin 3.5vmin 2vmin;
    }

    &__checkbox ::v-deep {
        width: 23%;
        margin: 1.13vmin 0;
        // font-size: 2vmin;
        font-size: 1.3vw;
        line-height: 2.1vw;
    }

    .q-option-group ::v-deep {
        .q-checkbox__inner {
            font-size: 2vw;
        }
        .q-checkbox__bg {
            width: 1.5vw;
            height: 1.5vw;
            border-radius: 50% !important;
        }
    }

    .q-checkbox ::v-deep {
        .q-checkbox__inner {
            font-size: 2vw;
        }
        .q-checkbox__bg {
            width: 1.5vw;
            height: 1.5vw;
            border-radius: 50% !important;
        }
    }

    .btn {
        border-radius: 1vmin;
        margin-bottom: 2vmin;
    }

    .close {
        margin: 1.5vmin;
    }

    .q-option-group {
        ::v-deep > div {
            width: 23%;
        }
    }

    .btn__filter {
        color: #000000;
        font-weight: 500;
        border: 1px solid #8e8e8e;
        border-radius: 1.33vmin;
        font-size: 1.2vw;
        padding: 1.17vmin 2.04vmin;
    }
    .btn__submit {
        width: 41.67vmin;
        height: 8.17vmin;
        font-size: 1.2vw;
        line-height: 1.6vw;
        border-radius: 1.33vmin;
    }
}

::v-deep {
    input {
        padding: 1.67vmin 1.33vmin 1.67vmin 2.83vmin;
        font-size: 1.2vw;
        color: $color_gray_900;
        line-height: 1.6vw;

        ::placeholder {
            color: $color_gray_600;
        }
    }

    button {
        min-height: inherit;
    }

    .q {
        &-field {
            margin-top: 0px;

            &__bottom {
                font-size: 1.1vw;
                font-weight: 500;
                line-height: 1.4vw;

                &--animated {
                    padding-top: 5px;
                }
            }

            &__control {
                border-radius: 1vmin;
                height: 100%;
                margin-bottom: 0;
            }

            &__label {
                top: 50%;
                left: 1.6vw;
                font-size: 1.2vw;
                color: $color_gray_600;
                line-height: 1.6vw;
                transform: translateY(-50%);
            }

            &--with-bottom {
                //padding-bottom: 3vmin;
                padding-bottom: 1.8vw;
            }

            &--float {
                .q-field__label {
                    top: 0.8vw;
                    font-size: 0.8vw;
                    @include transform(translateY(-40%));
                }
            }
        }

        &-item__label {
            font-size: 24px;
        }

        &-checkbox__label {
            margin-left: 1.67vmin;
        }
    }

    .filter__wrap {
        .block {
            font-weight: 700;
        }
        .filter__img {
            width: 2.4vw;
            height: 2.4vw;

            img {
                width: 1.33vw;
                height: 1.31vw;
                margin: 0 auto;
            }
        }
    }
    .search__input {
        .q-field__marginal {
            height: inherit;
        }
        .q-icon {
            width: 2.1vw;
            height: 2.1vw;
            padding: 0.66vmin 0.75vmin 0.77vmin 0.58vmin;
            // margin-right: 2.83vmin;
            box-sizing: border-box;
        }
    }
    .content__box {
        .q-hoverable:hover > .q-focus-helper {
            background: inherit !important;
        }
    }

    .q-btn__content {
        .block {
            font-weight: 500;
        }
    }
}
.btn__filter {
    min-height: inherit;
    padding: 1.08vmin 3.33vmin 1.08vmin 2.5vmin;
    border: 1px solid $color_gray_900;
    @include border-radius(1.33vmin);
    font-size: 1.2vw;
    line-height: 1.6vw;
    img {
        width: 1.33vw;
        height: 1.31vw;
        margin-right: 0.83vmin;
    }
}

.content__box {
    margin-top: 6.42vmin;
    .q-hoverable:hover > .q-focus-helper {
        background: inherit !important;
    }
}
.table__box {
    margin: 2vmin 0;
}

.map__title {
    margin-top: 2vmin;
}
.filterTt10 {
    margin: 0;
}
</style>
